import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useExcelStore = defineStore("excel", () => {
  const httpStore = useHttpStore()

  const excelContentTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12']

  const generateInMemoryExcelCustomDocument = (data, reportName) => {
    var params = {
      ClassName: reportName,
      ExcelData: JSON.stringify(data)
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "excelservices/GenerateInMemoryExcelCustomDocument", params, {
          showLoading: true,
          timeout: 0
        })
        .then((res) => {
          downloadInMemoryExcelDocument(res, reportName)
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const generateInMemoryExcelDocument = (data, className) => {
    var params = {
      ClassName: className,
      ExcelData: JSON.stringify(data)
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "excelservices/GenerateInMemoryExcelDocument", params, {
          showLoading: true,
          timeout: 0
        })
        .then((res) => {
          downloadInMemoryExcelDocument(res, className)
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const generateInMemoryExcelDocumentV2 = (data, reportName) => {
    var params = {
      ClassName: reportName,
      ExcelData: JSON.stringify(data)
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "excelservices/GenerateInMemoryExcelDocumentV2", params, {
          showLoading: true,
          timeout: 0
        })
        .then((res) => {
          downloadInMemoryExcelDocument(res, reportName)
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const downloadInMemoryExcelDocument = (res, docName) => {
    if (docName.length === 0) {
      docName = "Report"
    }
    var a = document.createElement("a")
    document.body.appendChild(a)
    a.style = "display: none"
    let url = window.URL.createObjectURL(base64toBlob(res))
    a.href = url
    a.download = docName + ".xlsx"
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  }

  const base64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    sliceSize = sliceSize || 512;
  
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
  
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
    
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
    
      var byteArray = new Uint8Array(byteNumbers);
    
      byteArrays.push(byteArray);
    }
  
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  const importExcelDocument = (base64Data, className, quarter, week) => {
    var params = {
      ClassName: className,
      ExcelData: base64Data,
      Quarter: quarter,
      Week: week
    };

    var options = {
      showLoading: true,
      timeout: 0
    }
   
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "excelservices/ImportExcelDocument", params, options)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getImportMappingData = (className) => {
    var params = {
      ClassName: className
    };
   
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "excelservices/GetImportMappingData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    generateInMemoryExcelDocument,
    generateInMemoryExcelDocumentV2,
    downloadInMemoryExcelDocument,
    importExcelDocument,
    getImportMappingData,
    generateInMemoryExcelCustomDocument,
    excelContentTypes
  };

})